module.exports = __webpack_public_path__ + "static/media/gold_offer.ad5e2836.jpg";